// in src/users.js
import React, {cloneElement} from 'react';
import {ReferenceManyField, Datagrid, EditButton, List, sanitizeListRestProps, TopToolbar, TextField, CreateButton} from 'react-admin';
import {AREAS, CITIES, COUNTRIES, CURRENCIES, IP_LISTS, SERVICES} from '../../consts/Names';
import {CitiesEdit} from "./CitiesEdit";
import {CitiesCreate} from "./CitiesCreate";
import {AreasEdit} from "./AreasEdit";
import {AreasCreate} from "./AreasCreate";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import {makeStyles, Theme} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        resource, showFilter, displayedFilters, filterValues, basePath, total, currentSort, permanentFilter,
        ...rest

    } = props;

    console.log(basePath)
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} label={'Create country'}/>
            <CreateButton basePath={'/cities'} label={'Create City'}/>
            <CreateButton basePath={'/areas'} label={'Create Area'}/>

        </TopToolbar>
    );
};
const ListActions1 = (props) => {

    return (
        <TopToolbar {...props}>
            <CreateButton basePath={'/currencies'} label={'ADD CURRENCY'}/>
        </TopToolbar>
    );
};
interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`wrapped-tabpanel-${index}`}
            aria-labelledby={`wrapped-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `wrapped-tab-${index}`,
        'aria-controls': `wrapped-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));
export const CountriesShow = (props) => {
    const [value, setValue] = React.useState('one');
    const classes = useStyles();
    const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
        setValue(newValue);
    };
    let areasBlock=<ReferenceManyField edit={AreasEdit} create={AreasCreate} reference={AREAS.SOURCE} target={AREAS.city_id}>
        <Datagrid>
            <TextField source={AREAS.name} />
            <TextField source={AREAS.city_id} />
            <EditButton/>
        </Datagrid>
    </ReferenceManyField>

    let citiesBlock = <ReferenceManyField edit={CitiesEdit} create={CitiesCreate} reference={CITIES.SOURCE} target={CITIES.country_id}>
        <Datagrid expand={areasBlock}>
            <TextField source={CITIES.name} />
            <TextField source={CITIES.country_id} />
            <EditButton/>
        </Datagrid>
    </ReferenceManyField>


   return (
       <div className={classes.root}>
           <AppBar position="static">
               <Tabs value={value} onChange={handleChange} aria-label="wrapped label tabs example">
                   <Tab
                       value="one"
                       label="Locations"
                       wrapped
                       {...a11yProps('one')}
                   />
                   <Tab value="two" label="Currencies" {...a11yProps('two')} />
               </Tabs>
           </AppBar>
           <TabPanel value={value} index="one">
              <List {...props} title="Countries" exporter={false} actions={<ListActions basePath={props.basePath} />}>
                 <Datagrid expand={citiesBlock}>
                    <TextField source={COUNTRIES.name} sortable={false} />
                    <EditButton />
                 </Datagrid>
              </List>
           </TabPanel>
           <TabPanel value={value} index="two">
               <List basePath={'/currencies'} title="Currencies" resource={CURRENCIES.SOURCE} exporter={false} actions={<ListActions1 basePath={'/currencies'}/>}>
                   <Datagrid>
                       <TextField source={CURRENCIES.name} sortable={false} />
                       <EditButton />
                   </Datagrid>
               </List>
           </TabPanel>
       </div>
   );
};